export default {
    searchTerm: "",
    currentUser: null,
  };